import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import api from '../services/api';

const S = {
  page:       { padding:'28px 20px', maxWidth:880, margin:'0 auto', fontFamily:'Poppins, sans-serif' },
  header:     { textAlign:'center', marginBottom:28 },
  h1:         { fontSize:'1.7rem', fontWeight:800, color:'var(--text-primary)', margin:'0 0 8px', display:'flex', alignItems:'center', justifyContent:'center', gap:10 },
  subtitle:   { color:'var(--text-muted)', fontSize:'0.95rem', maxWidth:560, margin:'0 auto' },
  askBar:     { display:'flex', justifyContent:'center', marginBottom:24 },
  askBtn:     { background:'#1e90ff', color:'#fff', border:'none', borderRadius:30, padding:'12px 28px', fontWeight:700, fontSize:'0.95rem', cursor:'pointer', display:'flex', alignItems:'center', gap:8, boxShadow:'0 4px 14px rgba(30,144,255,0.35)' },
  loginNote:  { textAlign:'center', color:'var(--text-muted)', fontSize:'0.9rem', marginBottom:24, background:'var(--bg-input)', borderRadius:12, padding:'14px 18px' },
  card:       { background:'var(--bg-card)', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.06)', padding:'20px 22px', marginBottom:16, cursor:'pointer', transition:'box-shadow .15s' },
  qTitle:     { fontSize:'1.05rem', fontWeight:700, color:'var(--text-primary)', margin:'0 0 6px' },
  qSnippet:   { color:'var(--text-muted)', fontSize:'0.9rem', margin:'0 0 10px', overflow:'hidden', textOverflow:'ellipsis', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' },
  qMeta:      { display:'flex', alignItems:'center', gap:14, fontSize:'0.8rem', color:'var(--text-muted)', flexWrap:'wrap' },
  badge:      { background:'#dcfce7', color:'#15803d', borderRadius:20, padding:'3px 10px', fontWeight:700, fontSize:'0.72rem', display:'inline-flex', alignItems:'center', gap:4 },
  badgePend:  { background:'#fef9c3', color:'#a16207', borderRadius:20, padding:'3px 10px', fontWeight:700, fontSize:'0.72rem', display:'inline-flex', alignItems:'center', gap:4 },
  empty:      { textAlign:'center', color:'var(--text-muted)', padding:'60px 20px' },
  backBtn:    { background:'none', border:'none', color:'#1e90ff', fontWeight:700, fontSize:'0.9rem', cursor:'pointer', marginBottom:18, display:'flex', alignItems:'center', gap:6, padding:0 },
  detailCard: { background:'var(--bg-card)', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.06)', padding:'24px 26px', marginBottom:24 },
  detailMeta: { fontSize:'0.82rem', color:'var(--text-muted)', marginBottom:10 },
  detailTitle:{ fontSize:'1.3rem', fontWeight:800, color:'var(--text-primary)', margin:'0 0 12px' },
  detailBody: { color:'var(--text-body)', fontSize:'0.96rem', lineHeight:1.6, whiteSpace:'pre-wrap' },
  repliesH:   { fontSize:'1.05rem', fontWeight:700, color:'var(--text-primary)', margin:'0 0 14px', display:'flex', alignItems:'center', gap:8 },
  reply:      { background:'var(--bg-card)', borderRadius:14, boxShadow:'0 2px 12px rgba(0,0,0,0.05)', padding:'16px 20px', marginBottom:12 },
  replyHead:  { display:'flex', alignItems:'center', gap:8, marginBottom:6, fontSize:'0.85rem', fontWeight:700, color:'var(--text-primary)' },
  replyDate:  { fontSize:'0.78rem', color:'var(--text-muted)', fontWeight:400, marginLeft:'auto' },
  replyBody:  { color:'var(--text-body)', fontSize:'0.92rem', lineHeight:1.55, whiteSpace:'pre-wrap' },
  form:       { background:'var(--bg-card)', borderRadius:16, boxShadow:'0 4px 20px rgba(0,0,0,0.06)', padding:'20px 22px' },
  label:      { fontSize:'0.85rem', fontWeight:700, color:'var(--text-primary)', marginBottom:6, display:'block' },
  input:      { width:'100%', padding:'11px 14px', borderRadius:10, border:'1px solid var(--border-md)', fontSize:'0.92rem', fontFamily:'Poppins, sans-serif', marginBottom:14, boxSizing:'border-box', background:'var(--bg-input)', color:'var(--text-primary)' },
  textarea:   { width:'100%', padding:'11px 14px', borderRadius:10, border:'1px solid var(--border-md)', fontSize:'0.92rem', fontFamily:'Poppins, sans-serif', resize:'vertical', minHeight:100, boxSizing:'border-box', marginBottom:14, background:'var(--bg-input)', color:'var(--text-primary)' },
  submitBtn:  { background:'#1e90ff', color:'#fff', border:'none', borderRadius:10, padding:'11px 24px', fontWeight:700, fontSize:'0.92rem', cursor:'pointer' },
  cancelBtn:  { background:'none', border:'none', color:'var(--text-muted)', fontWeight:600, fontSize:'0.88rem', cursor:'pointer', marginLeft:12 },
  notif:      { position:'fixed', bottom:24, right:24, background:'#1a2a4a', color:'#fff', padding:'12px 20px', borderRadius:10, fontSize:'0.88rem', fontWeight:600, boxShadow:'0 6px 20px rgba(0,0,0,0.2)', zIndex:200 },
};

function timeAgo(dateStr) {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1)  return 'Agora';
  if (m < 60) return `${m}min atrás`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h atrás`;
  return `${Math.floor(h / 24)}d atrás`;
}

export default function Forum() {
  const { user } = useAuth();
  const { dark } = useTheme();
  const replyProf = dark
    ? { background:'rgba(30,144,255,0.12)', border:'1px solid rgba(30,144,255,0.3)' }
    : { background:'#eff6ff', border:'1px solid #bfdbfe' };

  const [questions,   setQuestions]   = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [view,        setView]        = useState('list'); // 'list' | 'detail' | 'ask'
  const [detail,      setDetail]      = useState(null);
  const [notif,       setNotif]       = useState(null);

  const [askTitle,    setAskTitle]    = useState('');
  const [askContent,  setAskContent]  = useState('');
  const [asking,      setAsking]      = useState(false);

  const [replyText,   setReplyText]   = useState('');
  const [replying,    setReplying]    = useState(false);

  function showNotif(msg) {
    setNotif(msg);
    setTimeout(() => setNotif(null), 3000);
  }

  async function loadQuestions() {
    setLoading(true);
    try {
      const res = await api.get('/forum');
      setQuestions(res.data);
    } catch {
      showNotif('Erro ao carregar perguntas.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { loadQuestions(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  async function openQuestion(id) {
    try {
      const res = await api.get(`/forum/${id}`);
      setDetail(res.data);
      setView('detail');
      setReplyText('');
    } catch {
      showNotif('Erro ao carregar pergunta.');
    }
  }

  function backToList() {
    setView('list');
    setDetail(null);
  }

  function openAskForm() {
    if (!user) { showNotif('Faça login para fazer uma pergunta.'); return; }
    setView('ask');
    setAskTitle('');
    setAskContent('');
  }

  async function submitQuestion(e) {
    e.preventDefault();
    if (!askTitle.trim() || !askContent.trim()) return;
    setAsking(true);
    try {
      await api.post('/forum', { title: askTitle.trim(), content: askContent.trim() });
      showNotif('Pergunta enviada com sucesso!');
      setView('list');
      loadQuestions();
    } catch (err) {
      showNotif(err?.response?.data?.error || 'Erro ao enviar pergunta.');
    } finally {
      setAsking(false);
    }
  }

  async function submitReply(e) {
    e.preventDefault();
    if (!user) { showNotif('Faça login para responder.'); return; }
    if (!replyText.trim()) return;
    setReplying(true);
    try {
      const res = await api.post(`/forum/${detail.question.id}/replies`, { content: replyText.trim() });
      setDetail(d => ({ ...d, replies: [...d.replies, res.data] }));
      setReplyText('');
      showNotif('Resposta enviada!');
    } catch (err) {
      showNotif(err?.response?.data?.error || 'Erro ao enviar resposta.');
    } finally {
      setReplying(false);
    }
  }

  // ── Tela de fazer pergunta ──────────────────────────────
  if (view === 'ask') {
    return (
      <div style={S.page}>
        <button style={S.backBtn} onClick={() => setView('list')}>
          <i className="fas fa-arrow-left" /> Voltar
        </button>
        <div style={S.form}>
          <h2 style={{ ...S.h1, justifyContent:'flex-start', fontSize:'1.25rem', marginBottom:18 }}>
            <i className="fas fa-pen" style={{ color:'#1e90ff' }} /> Fazer uma pergunta
          </h2>
          <form onSubmit={submitQuestion}>
            <label style={S.label}>Título da pergunta</label>
            <input
              style={S.input}
              value={askTitle}
              onChange={e => setAskTitle(e.target.value)}
              placeholder="Ex: Qual a diferença entre 'make' e 'do'?"
              maxLength={255}
              required
            />
            <label style={S.label}>Detalhe sua dúvida</label>
            <textarea
              style={S.textarea}
              value={askContent}
              onChange={e => setAskContent(e.target.value)}
              placeholder="Explique sua dúvida com mais detalhes..."
              required
            />
            <button type="submit" style={S.submitBtn} disabled={asking}>
              {asking ? 'Enviando...' : 'Enviar pergunta'}
            </button>
            <button type="button" style={S.cancelBtn} onClick={() => setView('list')}>Cancelar</button>
          </form>
        </div>
        {notif && <div style={S.notif}>{notif}</div>}
      </div>
    );
  }

  // ── Tela de detalhe da pergunta ─────────────────────────
  if (view === 'detail' && detail) {
    const { question, replies } = detail;
    return (
      <div style={S.page}>
        <button style={S.backBtn} onClick={backToList}>
          <i className="fas fa-arrow-left" /> Voltar para o fórum
        </button>

        <div style={S.detailCard}>
          <div style={S.detailMeta}>
            Perguntado por <strong>{question.username}</strong> · {question.formatted_date}
          </div>
          <h1 style={S.detailTitle}>{question.title}</h1>
          <div style={S.detailBody}>{question.content}</div>
        </div>

        <h3 style={S.repliesH}>
          <i className="fas fa-comments" style={{ color:'#1e90ff' }} />
          {replies.length === 0 ? 'Ainda sem respostas' : `${replies.length} resposta${replies.length > 1 ? 's' : ''}`}
        </h3>

        {replies.map(r => (
          <div key={r.id} style={{ ...S.reply, ...(r.isAdmin ? replyProf : {}) }}>
            <div style={S.replyHead}>
              {r.isAdmin
                ? <span style={S.badge}><i className="fas fa-graduation-cap" /> Professor Dionísio</span>
                : <span>{r.username}</span>}
              <span style={S.replyDate}>{r.formatted_date}</span>
            </div>
            <div style={S.replyBody}>{r.content}</div>
          </div>
        ))}

        <div style={{ ...S.form, marginTop:20 }}>
          {user ? (
            <form onSubmit={submitReply}>
              <label style={S.label}>Sua resposta</label>
              <textarea
                style={S.textarea}
                value={replyText}
                onChange={e => setReplyText(e.target.value)}
                placeholder="Escreva sua resposta..."
                required
              />
              <button type="submit" style={S.submitBtn} disabled={replying}>
                {replying ? 'Enviando...' : 'Enviar resposta'}
              </button>
            </form>
          ) : (
            <div style={{ textAlign:'center', color:'#64748b', fontSize:'0.9rem' }}>
              <i className="fas fa-lock" style={{ marginRight:6 }} />
              Faça login para responder a esta pergunta.
            </div>
          )}
        </div>

        {notif && <div style={S.notif}>{notif}</div>}
      </div>
    );
  }

  // ── Lista de perguntas ──────────────────────────────────
  return (
    <div style={S.page}>
      <div style={S.header}>
        <h1 style={S.h1}>
          <i className="fas fa-comments" style={{ color:'#1e90ff' }} />
          Pergunte, Que o Professor Dionísio Responde
        </h1>
        <p style={S.subtitle}>
          Tem dúvidas sobre inglês? Faça sua pergunta e o professor Dionísio (ou outros alunos) podem te ajudar.
        </p>
      </div>

      <div style={S.askBar}>
        <button style={S.askBtn} onClick={openAskForm}>
          <i className="fas fa-plus" /> Fazer uma pergunta
        </button>
      </div>

      {!user && (
        <div style={S.loginNote}>
          <i className="fas fa-info-circle" style={{ marginRight:6, color:'#1e90ff' }} />
          Você pode ver todas as perguntas e respostas. Para perguntar ou responder, faça login.
        </div>
      )}

      {loading ? (
        <div style={S.empty}><i className="fas fa-spinner fa-spin fa-2x" /></div>
      ) : questions.length === 0 ? (
        <div style={S.empty}>
          <i className="fas fa-comment-dots fa-2x" style={{ marginBottom:12, display:'block' }} />
          Nenhuma pergunta ainda. Seja o primeiro a perguntar!
        </div>
      ) : (
        questions.map(q => (
          <div key={q.id} style={S.card} onClick={() => openQuestion(q.id)}>
            <h3 style={S.qTitle}>{q.title}</h3>
            <p style={S.qSnippet}>{q.content}</p>
            <div style={S.qMeta}>
              <span><i className="fas fa-user" style={{ marginRight:5 }} />{q.username}</span>
              <span><i className="fas fa-clock" style={{ marginRight:5 }} />{timeAgo(q.created_at)}</span>
              <span><i className="fas fa-comment" style={{ marginRight:5 }} />{q.reply_count} resposta{q.reply_count !== 1 ? 's' : ''}</span>
              {q.answered
                ? <span style={S.badge}><i className="fas fa-check-circle" /> Respondida pelo professor</span>
                : <span style={S.badgePend}><i className="fas fa-hourglass-half" /> Aguardando resposta</span>}
            </div>
          </div>
        ))
      )}

      {notif && <div style={S.notif}>{notif}</div>}
    </div>
  );
}
